<template>
  <VSelect
    :class="className"
    :value="value"
    :name="name"
    :options="options"
    :label="label"
    :reduce="reduce"
    @input="onChange"
    v-bind="mergedProps"
    :id="id"
  >
    <template #open-indicator="{ attributes }">
      <span v-bind="attributes"
        ><svg width="15" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.1016 1L10.5027 10.2588L0.903925 0.999999" stroke="#201E1E" stroke-width="2" />
        </svg>
      </span>
    </template>
    <input type="hidden" :value="value" :name="name" />
  </VSelect>
</template>

<script>
import VSelect from "vue-select"
import "vue-select/dist/vue-select.css"

export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Boolean],
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "name",
    },
    className: {
      type: String,
      default: null,
    },
    reduce: {
      type: Function,
      default: (options) => options.value,
    },
  },
  computed: {
    attributes() {
      return {
        ref: "openIndicator",
        role: "presentation",
        class: "vs__open-indicator",
      }
    },
    mergedProps() {
      // filterable, clearable, searchable and VSelect specific other props
      return {
        ...this.$attrs,
        ...this.$props,
      }
    },
  },
  methods: {
    onChange(value) {
      this.$emit("change", value)
      this.$emit("input", value) // supporting v-model
    },
  },
  components: {
    VSelect,
  },
}
</script>
